module.exports = __webpack_public_path__ + "static/media/Tutoring.439fab04.jpg";